<template>
  <div
    :id="id"
    class="p-v-select"
    :class="[className, { 'd-flex align-items-center': inline }]"
  >
    <div
      v-if="labelText"
      class="d-flex align-items-center"
      :class="[{ 'mb-2': !inline }]"
    >
      <div
        v-if="required"
        class="required-dot mb-0"
      />
      <label
        :for="id"
        v-bind="labelElProps"
      >
        {{ labelText }}
      </label>
    </div>
    <div :style="{ width: width }">
      <v-select
        :clearable="clearable"
        :searchable="searchable"
        :placeholder="placeholder"
        :options="options"
        v-bind="$attrs"
        v-on="$listeners"
        @blur="$emit('blur', $event.target.value)"
      >
        <template #open-indicator="{ attributes, events }">
          <span v-bind="attributes">
            <fa
              icon="chevron-down"
              class="open-indicator-chevron-down"
              :style="{ fontSize: arrowSize }"
            />
          </span>
          <input
            class="vs__search"
            placeholder="Select"
            :required="!dataValue"
            v-bind="attributes"
            v-on="events"
          >
        </template>

        <template #no-options>
          No Data Available
        </template>

        <template
          v-for="(_, slot) of $scopedSlots"
          #[slot]="scope"
        >
          <slot
            :name="slot"
            v-bind="scope"
          />
        </template>
      </v-select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PVSelect',
  inheritAttrs: false,
  props: {
    dataValue: {
      type: [String, Number],
      default: ''
    },
    width: {
      type: String,
      default: '100%'
    },
    required: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    className: {
      type: String,
      default: ''
    },
    labelText: {
      type: String,
      default: ''
    },
    labelElProps: {
      type: Object,
      default: null
    },
    clearable: {
      type: Boolean,
      default: false
    },
    searchable: {
      type: Boolean,
      default: false
    },
    inline: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => []
    },
    arrowSize: {
      type: String,
      default: '12px'
    },
    placeholder: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.p-v-select {
    width: 100%;

    ::v-deep {
        --vs-controls-color: rgba(0, 0, 0, 0.5);
        --vs-controls-size: .9;

        --vs-border-color: #E3E2E2;
        --vs-border-width: 1px;
        --vs-border-style: solid;
        --vs-border-radius: 0;

        --vs-dropdown-option-padding: 15px 10px;

        --vs-dropdown-option--active-bg: #E3E2E2;
        --vs-dropdown-option--active-color: #000000;

        .vs__dropdown-toggle {
            padding-top: 2px !important;
            padding-bottom: 2px !important;
        }

        .vs__selected {
            position: initial !important;
        }

        .vs__dropdown-menu {
            min-width: 0 !important;
        }

        .open-indicator-chevron-down {
            opacity: 0.3;
            font-size: 12px;
        }
    }

}
</style>
